module.exports = __webpack_public_path__ + "img/icon-white-61.e681aaa4.svg";